import { put, takeEvery } from 'redux-saga/effects';
import { call } from 'typed-redux-saga';
import { logisticsActionCreators, LogisticsActionKeys, UpdateLoadFees } from '..';
import { showFailedRequestDialog } from '../../sagaUtils';
import { uiActionCreators } from '../../ui';
import { updateLoadFees } from '../logisticsApi';

function* updateLoadFeesSaga(action: UpdateLoadFees) {
  yield put(uiActionCreators.showSpinnerDialog());
  const response = yield* call(updateLoadFees, action.payload.loadNumber, action.payload.loadFees);

  if (response.requestFailed) {
    yield showFailedRequestDialog(response);
  } else if (response.value) {
    yield put(logisticsActionCreators.setLoad(response.value));
  }

  yield put(uiActionCreators.hideSpinnerDialog());
}

export function* watchUpdateLoadFees() {
  yield takeEvery(LogisticsActionKeys.UPDATE_LOAD_FEES, updateLoadFeesSaga);
}
